import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import FaceRetouchingOffIcon from "@mui/icons-material/FaceRetouchingOff";
import PersonOffIcon from "@mui/icons-material/PersonOff";
import FaceIcon from "@mui/icons-material/Face";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";

import { LiveStreamFeedType } from "./types/LiveStreamFeedType";
import { mod } from "utils/mod";

export interface LiveStreamFeedTypeButtonProps {
    availableLiveStreamFeedTypes: LiveStreamFeedType[];
    selectedLiveStreamFeedType: LiveStreamFeedType;
    onChange: (liveStreamFeedType: LiveStreamFeedType) => void;
}

export function LiveStreamFeedTypeButton(props: LiveStreamFeedTypeButtonProps) {
    const onClickHandler = () => {
        const previousIndex = mod(
            props.availableLiveStreamFeedTypes.indexOf(
                props.selectedLiveStreamFeedType,
            ) - 1,
            props.availableLiveStreamFeedTypes.length,
        );
        const nextAvailableLiveStreamFeedType =
            props.availableLiveStreamFeedTypes[previousIndex];

        props.onChange(nextAvailableLiveStreamFeedType);
    };

    let selectionIcon;
    switch (props.selectedLiveStreamFeedType) {
        case LiveStreamFeedType.Original:
            selectionIcon = <FaceIcon color="primary" />;
            break;

        case LiveStreamFeedType.FaceAnonymized:
            selectionIcon = <FaceRetouchingOffIcon />;
            break;

        case LiveStreamFeedType.PersonAnonymized:
            selectionIcon = <PersonOffIcon />;
            break;

        default:
            selectionIcon = <QuestionMarkIcon />;
            break;
    }

    return (
        <>
            {props.availableLiveStreamFeedTypes.length > 1 && (
                <Tooltip title="Change the live stream feed type">
                    <IconButton onClick={onClickHandler}>
                        {selectionIcon}
                    </IconButton>
                </Tooltip>
            )}
        </>
    );
}
